import axiosInstance from "../configs/axios/axiosInstance";
import { ApiValueResponse } from "../types/apiResponse";
import { ExecutionLogsInfoResponse, LogsList } from "../types/commonTypes";

const BulkImportServices = {

    getLogs: async (payload: any): Promise<ApiValueResponse<LogsList>> => {
        const response = await axiosInstance.get('Utilities/GetExecutionLogs', {params: payload});
        return response.data;
    },

    getLogDetails: async (logID: string): Promise<ApiValueResponse<ExecutionLogsInfoResponse>> => {
        const params = { logID };
        const response = await axiosInstance.get('Utilities/GetExecutionLogDetails', { params: params });
        return response.data;
    },

};

export default BulkImportServices;
